// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import history from '../../services/history'
import { Row, Col, Tabs, Alert, Input, Spin } from 'antd'
import { StyledAutoComplete, StyledCapital } from './style'
import TableCompanyHistory from '../table-company-history'
import ChartView from '../view-chart'
import FinancialInfo from '../view-fincancials'
import AnalyzeTrade from '../view-trades/AnalyzeTrade'
import News from '../view-news'
import Axios from 'axios'
import Profile from '../view-profile'
import OptionBook from '../option-book'
import { StyledContent } from '../view-earnings/style'
import { getPastEarnings, updateEarningsHistory } from '../../actions/earnings'
const TabPane = Tabs.TabPane
const currDate = moment(new Date()).unix();

type Props = {
  history: [],
  match: Object,
  onGetPastEarnings: string => void,
  onResetEarningsHistory: Object[] => void,
  pastEarningsTargets: Object[]
}

type State = {
  symbols: string[],
  selectedTab: string,
  target: string,
  error: null | string,
  isLoading: boolean,
  selValue: string,
  currentSymbol: Object,
}

class StocksView extends Component<Props, State> {

  state: State = {
    symbols: [],
    selectedTab: this.props.match.params.tab || 'company-view',
    target: (this.props.match.params && this.props.match.params.symbol) || localStorage.getItem('stockSymbol') || 'SPY',
    error: '',
    isLoading: false,
    currentSymbol: null,
    selValue: (this.props.match.params && this.props.match.params.symbol) || localStorage.getItem('stockSymbol') || 'SPY',
  }

  componentWillMount() {
      const {
          onGetPastEarnings,
          onResetEarningsHistory
      } = this.props
      let symbol = this.props.match.params.symbol;
      if (!symbol) {
        symbol = localStorage.getItem('stockSymbol') || 'SPY';
        this.props.history.replace(`/stocks/${symbol}`);
      } else {
        localStorage.setItem('stockSymbol', symbol);
      }
      if (symbol) onGetPastEarnings(symbol)
      else if (!symbol) onResetEarningsHistory([])
  }

  componentDidMount() {

    this.getSymbols();
    let target = this.props.match.params.symbol || localStorage.getItem('stockSymbol') || 'SPY';
    this.getCurrentSymbolData(target);
    this.setState({ target });
  }

  getSymbols = async () => {
    try {

      const response = await Axios.get(`https://cloud.iexapis.com/v1/ref-data/symbols?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`)

      if (response && response.data && Array.isArray(response.data)) {

        const symbols = response.data

        this.setState({
          symbols: symbols.map(x => x.symbol),
          symbolsData: [],
          isLoading: false
        })
      }

    } catch(err) {

      this.setState({
        error: 'something went wrong',
        isLoading: false
      })
    }
  }

  getCurrentSymbolData = async (symbol) => {
      const self = this;
      this.setState({
        isLoading: true
      });
      const response = await Axios.get(`https://cloud.iexapis.com/v1/stock/${symbol}/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`).catch((err) => {
        self.setState({
          error: 'No data found for this symbol!'
        });
      })
      if(response && response.data) {
          this.setState({
              currentSymbol: response.data,
              isLoading: false,
              error: null,
          })
      } else {
        this.setState({
          error: 'No data found for this symbol!',
          isLoading: false
        })
      }
  }

  handleTabChange = (selectedTab: string) => {
    this.setState({ selectedTab });
    const { target } = this.state;
    this.props.history.push(`/stocks/${target}/${selectedTab}`);
  }

  onSelect = (value: string) => {
    const {
        onGetPastEarnings,
        onResetEarningsHistory
    } = this.props
    localStorage.setItem('stockSymbol', value);
    if (value !== this.props.match.params.symbol) {
      this.props.history.replace(`/stocks/${value}/${this.state.selectedTab}`)
      this.getCurrentSymbolData(value);
      this.setState({
        selValue: value,
        target: value,
        isLoading: true,
        currentSymbol: null,
      }, () => {

        if (value) onGetPastEarnings(value)
        else if (!value) onResetEarningsHistory([])
        this.setState({ isLoading: false })
      })
    }
  }

  getEarningInThirty = () => {
      let inThirty = {}
      const currDateToMonth = moment(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)).unix();
      this.props.pastEarningsTargets.forEach(history => {
          const date = moment(history.earningsDateFull).unix()
          if(currDate < date && date < currDateToMonth) {
              inThirty.earningsDateFull = history.earningsDateFull
              inThirty.estimatedEPS = history.estimatedEPS
          }
      })
      return inThirty
  }

  handleSearch = (value) => {
    this.setState({
      symbolsData: !value ? [] : [
        ...this.state.symbols.filter(x=>x.toLowerCase().indexOf(value.toLowerCase()) > -1)
      ],
    });
  }
  
  onChange = (value) => {
    this.setState({
      symbolValue: value,
    })
  }
  
  onKeyUp = (e) => {
    if (e.keyCode === 13) {
      this.onSelect(e.target.value);
      
    }
  }

  render() {
    const {target, isLoading, currentSymbol, selValue, symbolsData, selectedTab, error} = this.state
    const inThirty = this.getEarningInThirty()
    return (
      <Row>
        <Col span={24}>
          <StyledContent>
            <div className='text-center'>
              <StyledAutoComplete
                  dataSource={symbolsData}
                  onSelect={this.onSelect}
                  onChange={this.onChange}
                  onSearch={this.handleSearch}
                  placeholder='Start typing to search symbols'
                >
                <Input onKeyUp={this.onKeyUp} />
              </StyledAutoComplete>
            </div>
            {
              selValue && currentSymbol &&
              <Tabs
                activeKey={selectedTab}
                onChange={this.handleTabChange}>

                <TabPane tab='Company View' key='company-view'>
                  {
                    inThirty.earningsDateFull ?
                      <Alert message={<p>Earnings Data: <b style={{color: "#000000"}}>{moment(inThirty.earningsDateFull).format('ddd DD MMM')}</b>&nbsp;&nbsp;After Market Close (Confirmed)<b style={{float: 'right'}}>Estimate: {inThirty.estimatedEPS}</b></p>}
                             type="info"
                             style={{backgroundColor: '#75beda',fontSize: 19, color: 'white',fontWeight: 'bold'}}/>
                      : null
                  }
                  <h4><b>{currentSymbol.companyName} <StyledCapital>({target})</StyledCapital></b></h4>
                  <h3><b>{currentSymbol.latestPrice}</b> <small>real time price as of {currentSymbol.latestTime}</small></h3>
                  {!isLoading && <ChartView symbol={target} /> }
                </TabPane>

                <TabPane tab='Earnings History' key='earnings'>
                  { !isLoading && <TableCompanyHistory symbol={target} /> }
                </TabPane>

                <TabPane tab='Profile' key='profile'>
                  { !isLoading && <Profile symbol={target}/>}
                </TabPane>

                <TabPane tab='Financials' key='financials'>
                  { !isLoading && <FinancialInfo symbol={target} />}
                </TabPane>

                <TabPane tab='News' key='news'>
                  { !isLoading && <News symbol={target}/>}
                </TabPane>

                <TabPane tab="Option Chain" key='option-chain'>
                  <OptionBook symbol={target} />
                </TabPane>
  
                <TabPane tab="Analyze" key='analyze'>
                  {
                    selectedTab === 'analyze' && <AnalyzeTrade symbol={target} />
                  }
                </TabPane>

              </Tabs>
            }
            {
              error && <div style={{width: '100%', textAlign: 'center', marginTop: 50}}>{error}</div>
            }
            {
              isLoading && <div style={{width: '100%', textAlign: 'center', marginTop: 50}}><Spin size="big"/></div>
            }
          </StyledContent>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = (state: Object) => ({
    pastEarningsTargets: state.earnings.pastEarningsTargets
})

const mapDispatchToProps = (dispatch: Function) => ({
    onGetPastEarnings(symbol: string) {
        getPastEarnings(dispatch, symbol)
    },
    onResetEarningsHistory(reset: Object[]) {
        dispatch(updateEarningsHistory(reset))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(StocksView)



// WEBPACK FOOTER //
// ./src/components/view-stocks/index.js